<template>
  <div :class="['card-item', { 'card-item--has-items': Boolean(value.items && value.items.length) }]">
    <div v-if="value.parent" class="card-item__parent">
      <Card :value="value.parent" />
    </div>
    <Card v-else-if="value" :value="value" />

    <!-- Render children recursively -->
    <div v-if="value.items && value.items.length" class="card-item__items-wrapper">
      <strong>Relaterte enhetstyper til: {{ value.parent.internalName }}: </strong>
      <div class="card-item__items">
        <CardItem v-for="child in value.items" :key="child.id" :value="child" />
      </div>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue'
export default {
  name: 'CardItem', // MUST have a name for recursion
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
.card-item {
  &--has-items:nth-child(2) {
    flex-direction: row;
  }
  &--has-items {
    grid-column: 1 / -1;
    display: flex;
    grid-gap: $form-gap;
    .card-item__parent {
      max-width: 335px;
      width: 100%;
    }
  }

  &__items {
    &-wrapper {
      border-radius: var(--border-radius);
      flex: 1;
      display: flex;
      flex-direction: column;
      background-color: $grey;
      padding: 1rem;
      gap: 1rem;
      justify-content: space-between;
    }
    margin-bottom: 1rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    grid-gap: 1rem;
  }
}
</style>
